import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormStatus, LoadBankType } from '../models/Enums';
import { LoadBankApplyLoads } from '../models/LoadBankApplyLoads';
import { LoadBankApplyParameters } from '../models/LoadBankApplyParameters';
import { LoadBankItem } from '../models/LoadBankItem';
import { LoadBankDataService } from '../services/load-bank.service';

@Component({
    selector: 'load-bank-apply',
    templateUrl: 'load-bank-apply.component.html',
    styles: [],
    standalone: false
})
export class LoadBankApplyComponent implements OnInit, OnChanges {

    constructor(private _loadBankService: LoadBankDataService, private cdr: ChangeDetectorRef) {

    }

    @ViewChild('closeButton') closeButton;
    @ViewChild('closeChildButton') closeChildButton;
    @Input() parameters: LoadBankApplyParameters = new LoadBankApplyParameters();
    @Input() loadBankApplyFormId: string = 'loadBankApplyModal';
    @Input() isMobile?: boolean = false;
    @Output() loadBankApply: EventEmitter<LoadBankItem> = new EventEmitter<LoadBankItem>();
    @Output() loadBankApplyComplete: EventEmitter<number> = new EventEmitter<number>();
    @Output() loadBankApplyCompleteForDispatchMobile: EventEmitter<any> = new EventEmitter<any>();



    loadBankType: string = 'Load';
    locationType: string = 'Origin';
    isChildModal: boolean = false;
    isLoading: boolean = false;
    errorMessage: string = '';
    readonly FormStatus = FormStatus;
    formStatus: FormStatus = FormStatus.Normal;

    applyParameters: LoadBankApplyParameters = new LoadBankApplyParameters();
    loadBankList: LoadBankItem[] = [];

    selectLoadNumber(index: number) {
        let loadsCount: number = this.applyParameters.loadIds.length;
        var isSelected = this.loadBankList[index].selected;
        let selectedItems = this.loadBankList.filter(item => item.selected);
        if (loadsCount > 1 && isSelected && selectedItems.length == 1) {
            //auto select matching number of loads
            for (let i = 0; i < loadsCount; i++) {
                let selectIndex = i + index;
                if (selectIndex < this.loadBankList.length) {
                    this.loadBankList[selectIndex].selected = true;
                }
                else {
                    break;
                }
            }
        }
    }

    applyLoadNumbers() {
        this.formStatus = FormStatus.Saving;
        this.errorMessage = '';
    
        const selectedLoadBankItems = this.loadBankList.filter(item => item.selected);
    
        if (selectedLoadBankItems.length === 0) {
            this.errorMessage = `You must select a ${this.loadBankType.toLowerCase()} number to apply.`;
            this.formStatus = FormStatus.Normal;
            return;
        }
    
        const parameters = new LoadBankApplyLoads();
        parameters.loadIds = this.applyParameters.loadIds;
        parameters.loadBankIds = selectedLoadBankItems.map(item => item.loadBankId);
    
        if (this.applyParameters.loadIds.length > 0) { 
            this._loadBankService.saveLoadNumbersToLoads(parameters).subscribe({
                next: () => {
                    this.loadBankApplyComplete.emit(this.applyParameters.dispatchId);
                    this.closeModal();
                },
                error: err => {
                    this.errorMessage = err;
                    this.formStatus = FormStatus.Normal;
                }
            });
        } else { 
            const firstSelectedLoadBankItem = selectedLoadBankItems[0];
    
            if (this.isMobile) {
                this.loadBankApply.emit(firstSelectedLoadBankItem);
                this.loadBankApplyCompleteForDispatchMobile.emit({
                    dispatchId: this.applyParameters.dispatchId,
                    loadBankApplyLoads: parameters
                });
            } else {
                this.loadBankApply.emit(firstSelectedLoadBankItem);
            }
    
            this.closeModal();
        }
    }
    

    closeModal() {
        this.loadBankList = [];
        if (this.isChildModal) {
            this.closeChildButton.nativeElement.click();
        }
        else {
            this.closeButton.nativeElement.click();
        }
    }

    getLoadBankApplyInfo(): void {
        this.formStatus = FormStatus.Normal;
        if (this.applyParameters.locCode.length > 0 || this.applyParameters.dispatchId > 0) {
            this.isLoading = true;
            this._loadBankService.getLoadBankApplyInfo(this.applyParameters).subscribe({
                next: data => {
                    this.applyParameters = data.parameters;
                    this.loadBankList = data.loadBankList;
                    this.isLoading = false;
                },
                error: err => {
                    this.errorMessage = err;
                    this.isLoading = false;
                }
            });
        }
    }

    getloadBankList() {
        if (this.applyParameters.locCode.length == 0) {
            return;
        }

        this.loadBankList = [];
        this.isLoading = true;
        this._loadBankService.searchLoadBank(this.applyParameters).subscribe({
            next: data => {
                this.loadBankList = data;
                this.isLoading = false;
            },
            error: err => {
                this.errorMessage = err;
                this.isLoading = false;
            }
        });
    }

    setTypeNames() {
        if (this.applyParameters.loadBankType == LoadBankType.Load) {
            this.loadBankType = 'Load';
            this.locationType = "Origin";
        }
        else {
            this.loadBankType = 'Unload';
            this.locationType = 'Destination';
        }

        this.isChildModal = this.applyParameters.parentModal.length > 0;
    }

    resetComponent() {
        this.formStatus = FormStatus.Normal;
        this.errorMessage = '';
        this.setTypeNames();
        this.loadBankList = [];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['parameters']) {
            this.applyParameters = { ...this.parameters };
            this.resetComponent();
            this.getLoadBankApplyInfo();
        }
    }

    ngOnInit(): void {
        //if (window.innerWidth <= appSettings.mobileBreakpoint) {
        //    this.isMobile = true;
        //}
    } 

}
